import { useEffect, useState, memo } from 'react';
import { getAdminUserRoles } from '../../../common/constants';
import { useTranslation } from 'react-i18next';
import { SelectInput } from '../../molecules/AdminFilters/SelectInput';

interface userDropDownProps {
    selectedRole: any;
    userRole: any;
    updateUserRole: any;
    useData: any;
}

export const UserRoleDropDown = memo(({ selectedRole, userRole, updateUserRole, useData }: userDropDownProps) => {
    const { t } = useTranslation();
    const admin_userRoles = getAdminUserRoles(t);
    const userRoleOptions = admin_userRoles.filter((item) => item.accessibleTo.includes(userRole));
    const [value, setValue] = useState(selectedRole);

    useEffect(() => {
        setValue(selectedRole);
    }, [selectedRole]);

    const handleChange = (role?: string) => {
        // User role is not updated upfront, but the value is driven by the
        // `selectedRole` prop, which only changes after the API confirms success (via Redux).
        // On failure, the dropdown keeps showing the original role.
        updateUserRole({ ...useData, userType: role });
    };

    return (
        <SelectInput
            name={`user-role-${useData?.id ?? ''}`}
            value={value}
            options={userRoleOptions}
            maxWidth={130}
            onChange={handleChange}
        />
    );
});

UserRoleDropDown.displayName = 'UserRoleDropDown';
